import mutations from './restriction.mutations'
import actions from './restriction.actions'
import getters from './restriction.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
